var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDepression(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 70,
    viewBox: "0 0 66 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4112 54.114C59.0118 48.7304 62.5002 41.1568 62.5002 32.7645C62.5026 16.4264 49.2779 3.18115 32.9652 3.18115C16.6524 3.18115 3.42773 16.4264 3.42773 32.7645C3.42773 49.1026 16.6524 62.3478 32.9652 62.3478C36.6981 62.3478 40.2704 61.6515 43.5574 60.386L55.9909 66.8189L53.4112 54.114Z",
    stroke: "white",
    strokeWidth: 5.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 45C41.0021 41.1081 37.0907 38.3333 32.5 38.3333C27.9093 38.3333 23.9979 41.1094 22.5 45",
    stroke: "white",
    strokeWidth: 5.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0211 25.6C27.0211 27.7732 25.2637 29.5334 23.0939 29.5334C20.9242 29.5334 19.1667 27.7732 19.1667 25.6C19.1667 23.4269 20.9242 21.6667 23.0939 21.6667C25.2595 21.6667 27.0211 23.4269 27.0211 25.6Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0211 25.6C47.0211 27.7732 45.2637 29.5334 43.0939 29.5334C40.9242 29.5334 39.1667 27.7732 39.1667 25.6C39.1667 23.4269 40.9242 21.6667 43.0939 21.6667C45.2637 21.6667 47.0211 23.4269 47.0211 25.6Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepression);
export default __webpack_public_path__ + "static/media/depression.adcc8cd3981a961069b3fd1d487706dc.svg";
export { ForwardRef as ReactComponent };